import script from "./BriefcaseUserList.vue?vue&type=script&setup=true&lang=js"
export * from "./BriefcaseUserList.vue?vue&type=script&setup=true&lang=js"

import "./BriefcaseUserList.vue?vue&type=style&index=0&id=f119a6fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f119a6fa"]])

export default __exports__